import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

interface SourceStateCardProps {
  icon: LucideIcon;
  title: string;
  children?: ReactNode;
}

export function SourceStateCard({ icon: Icon, title, children }: SourceStateCardProps) {
  return (
    <div className="m-2 flex flex-col items-center justify-center rounded-md border border-gray-200 bg-gray-50 p-6">
      <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
        <Icon className="h-6 w-6 text-gray-400" />
      </div>
      <p className="text-center text-sm font-medium text-gray-600">{title}</p>
      {children && <div className="mt-1 text-center text-xs text-gray-500">{children}</div>}
    </div>
  );
}
